module.exports = __webpack_public_path__ + "static/assets/687427ad34f3deec13445f91a4c6ff71.svg";